export default "__VITE_ASSET__DPKjVQkP__"